function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30 .556H0v28.8h30V.556z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#XRP_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 29.4c3.47 0 6.833-1.155 9.516-3.269 2.683-2.113 4.519-5.054 5.196-8.322.677-3.267.153-6.659-1.483-9.597-1.636-2.938-4.282-5.24-7.488-6.516a15.585 15.585 0 00-10.095-.476C7.325 2.187 4.456 4.23 2.528 7 .6 9.77-.268 13.096.072 16.41c.34 3.316 1.868 6.415 4.321 8.771C7.206 27.882 11.022 29.4 15 29.4z",
  fill: "#23292F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.488 8.867h2.256l-4.69 4.492a4.44 4.44 0 01-3.073 1.222 4.44 4.44 0 01-3.072-1.221L7.232 8.867h2.253l3.562 3.412a2.813 2.813 0 001.946.774c.73 0 1.43-.278 1.946-.774l3.55-3.412zM9.474 21.362H7.232l4.706-4.521a4.44 4.44 0 013.073-1.221 4.44 4.44 0 013.072 1.22l4.715 4.522h-2.25l-3.588-3.44a2.813 2.813 0 00-1.946-.774c-.73 0-1.43.278-1.946.773l-3.594 3.44z",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "XRP_svg__clip0_1_137"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgXrp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#XRP_svg__clip0_1_137)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "XRP_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _ref), _ref2), _ref3);
}

export default __webpack_public_path__ + "43ac90ec58609f23b8e6d40930d96538.svg";
export { SvgXrp as ReactComponent };